import store from '@/store'
import router from '@/router'
import axios from 'axios'
import {
  Message
} from 'element-ui'
import util from '@/libs/util'

// 创建一个错误
function errorCreate(msg) {
  const error = new Error(msg)
  errorLog(error)
  throw error
}

// 记录和显示错误
function errorLog(error) {
  // 添加到日志
  store.dispatch('d2admin/log/push', {
    message: '数据请求异常',
    type: 'danger',
    meta: {
      error
    }
  })
  // 打印到控制台
  if (process.env.NODE_ENV === 'development') {
    util.log.danger('>>>>>> Error >>>>>>')
    console.log(error)
  }
  // 显示提示
  Message({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  })
}

// 创建一个 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 5000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    if (config.method === 'post') {
      for (const key in config.data) { // 去除对象内多余的空值key
        if (config.data[key] === '') {
          delete config.data[key]
        }
        //这里对页面进行单独处理，从 0 开始
        if (key == 'size') {
          config.data.size -= 1;
        }
      }

      //为post请求重新写入一个params参数
      config.params = config.data;
    }




    // 在请求发送之前做一些处理
    const token = util.cookies.get('token')
    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    if (token) {
      config.headers['Authorization'] = token
      config.headers['AccessToken-Agent'] = token
    }
    return config
  },
  error => {
    // 发送失败
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    if (response.data.code == 0) {
      response.data.code = 200
    }


    // dataAxios 是 axios 返回数据中的 data
    const dataAxios = response.data

    // console.log("返回信息", dataAxios)

    // 这个状态码是和后端约定的
    const code = dataAxios.errCode

    // 根据 code 进行判断
    if (code === undefined) {
      // 如果没有 code 代表这不是项目后端开发的接口 比如可能是 D2Admin 请求最新版本
      return dataAxios
    } else {
      console.log("请求状态", code)
      // 有 code 代表这是一个后端接口 可以进行进一步的判断
      switch (code) {
        case 0:
          // [ 示例 ] code === 0 代表没有错误
          return dataAxios.data
        case 1001:
          // [ 示例 ] 其它和后台约定的 code
          errorCreate(`[ code: 1001 ] ${dataAxios.data}: ${response.config.url}`)
          break
        case 2001:

          // [ 登陆失效 ] 
          // 删除cookie
          util.cookies.remove('token')
          util.cookies.remove('uuid')
          util.cookies.remove('name')
          // 清空 vuex 用户信息
          store.dispatch('d2admin/user/set', {}, {
            root: true
          })
          // 跳转路由
          router.push({
            name: 'login'
          })
          errorCreate(`${'登录失效'}`)
          break

        default:
          // 不是正确的 code
          errorCreate(`${dataAxios.data}: ${response.config.url}`)
          break
      }
    }
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误';
          break
        case 401:
          error.message = '未授权，请登录';
          break
        case 403:
          error.message = '拒绝访问';
          break
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`;
          break
        case 408:
          error.message = '请求超时';
          break
        case 500:
          error.message = '服务器内部错误';
          break
        case 501:
          error.message = '服务未实现';
          break
        case 502:
          error.message = '网关错误';
          break
        case 503:
          error.message = '服务不可用';
          break
        case 504:
          error.message = '网关超时';
          break
        case 505:
          error.message = 'HTTP版本不受支持';
          break
        default:
          break
      }
    }
    errorLog(error)
    return Promise.reject(error)
  }
)

export default service